import NotInvited from './NotInvited.component';

export default NotInvited;
